module.exports = __webpack_public_path__ + "img/delvium-logo.b412f521.png";